import { createFileRoute } from '@tanstack/react-router';
import { NpLoadPage } from '@features/admin/np-load';

export const Route = createFileRoute('/admin/np-load/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <NpLoadPage />;
}
